// extracted by mini-css-extract-plugin
export default {"flowCard":"flowCard-4ba2","disabled":"disabled-a20d"};